/** True on macOS / iOS, where the primary shortcut modifier is Cmd (⌘), not Ctrl. */
export function isMac(): boolean {
  if (typeof navigator === 'undefined') return false;
  // Prefer the non-deprecated userAgentData.platform; fall back to navigator.platform
  // (still universal, and where iPadOS reports "MacIntel"). The regex matches both.
  const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
  const platform = nav.userAgentData?.platform || navigator.platform || '';
  return /mac|iphone|ipad|ipod/i.test(platform);
}

export function getShortcutModifier(): string {
  return isMac() ? '⌘' : 'Ctrl';
}
